// img
import avatar10 from "assets/images/users/32/avatar-10.jpg";
import avatar9 from "assets/images/users/32/avatar-9.jpg";
import avatar8 from "assets/images/users/32/avatar-8.jpg";
import avatar7 from "assets/images/users/32/avatar-7.jpg";
import avatar6 from "assets/images/users/32/avatar-6.jpg";
import avatar5 from "assets/images/users/32/avatar-5.jpg";
import avatar4 from "assets/images/users/32/avatar-4.jpg";
import avatar3 from "assets/images/users/32/avatar-3.jpg";
import avatar2 from "assets/images/users/32/avatar-2.jpg";
import avatar1 from "assets/images/users/32/avatar-1.jpg";

const instructor = [
    {
        id: 1,
        img: { priview: avatar10, formattedSize: "4.87 KB", path: "img-10.png", size: '3000' },
        imgalt: "avatar-10.jpg",
        name: "Domenic Dach",
        totalcourse: "356",
        email: "domenic@steex.com",
        experience: "9 Months",
        students: "320",
        contact: "+(532) 01523 14587",
        rating: "4.9",
        status: "Active"
    }, {
        id: 2,
        img: { priview: avatar9, formattedSize: "4.87 KB", path: "img-9.png", size: '3000' },
        imgalt: "avatar-9.jpg",
        name: "Prezy Mark",
        totalcourse: "315",
        email: "prezy@steex.com",
        experience: "1 Years",
        students: "159",
        contact: "+(159) 65432 15987",
        rating: "4.8",
        status: "Unactive"
    }, {
        id: 3,
        img: { priview: avatar8, formattedSize: "4.87 KB", path: "img-8.png", size: '3000' },
        imgalt: "avatar-8.jpg",
        name: "Nelson Schaden",
        totalcourse: "852",
        email: "nelson@steex.com",
        experience: "8 Months",
        students: "362",
        contact: "+(251) 12365 47896",
        rating: "4.2",
        status: "Active"
    }, {
        id: 4,
        img: { priview: avatar7, formattedSize: "4.87 KB", path: "img-7.png", size: '3000' },
        imgalt: "avatar-7.jpg",
        name: "Deondre Huel",
        totalcourse: "485",
        email: "deondre@steex.com",
        experience: "3 Years",
        students: "321",
        contact: "+(025) 1592 15236",
        rating: "4.6",
        status: "Active"
    }, {
        id: 5,
        img: { priview: avatar6, formattedSize: "4.87 KB", path: "img-6.png", size: '3000' },
        imgalt: "avatar-6.jpg",
        name: "Sarai Schmidt",
        totalcourse: "320",
        email: "sarai@steex.com",
        experience: "5 Years",
        students: "364",
        contact: "+(123) 01592 36544",
        rating: "4.7",
        status: "Active"
    }, {
        id: 6,
        img: { priview: avatar5, formattedSize: "4.87 KB", path: "img-5.png", size: '3000' },
        imgalt: "avatar-5.jpg",
        name: "Ophelia Steuber",
        totalcourse: "485",
        email: "ophelia@steex.com",
        experience: "6 Years",
        students: "84",
        contact: "+(321) 01234 56987",
        rating: "4.4",
        status: "Unactive"
    }, {
        id: 7,
        img: { priview: avatar4, formattedSize: "4.87 KB", path: "img-4.png", size: '3000' },
        imgalt: "avatar-4.jpg",
        name: "Nelson Schaden",
        totalcourse: "258",
        email: "nelson@steex.com",
        experience: "2 Years",
        students: "146",
        contact: "+(159) 98745 63210",
        rating: "4.8",
        status: "Active"
    }, {
        id: 8,
        img: { priview: avatar3, formattedSize: "4.87 KB", path: "img-3.png", size: '3000' },
        imgalt: "avatar-3.jpg",
        name: "Zachary Stokes",
        totalcourse: "365",
        email: "zachary@steex.com",
        experience: "7 Months",
        students: "120",
        contact: "+(120) 12435 69870",
        rating: "4.9",
        status: "Active"
    }, {
        id: 9,
        img: { priview: avatar2, formattedSize: "4.87 KB", path: "img-2.png", size: '3000' },
        imgalt: "avatar-2.jpg",
        name: "Ayaan Bowen",
        totalcourse: "162",
        email: "ayaan@steex.com",
        experience: "1 Years",
        students: "79",
        contact: "+(152) 15963 24785",
        rating: "4.7",
        status: "Unactive"
    }, {
        id: 10,
        img: { priview: avatar1, formattedSize: "4.87 KB", path: "img-1.png", size: '3000' },
        imgalt: "avatar-1.jpg",
        name: "Themesbrand",
        totalcourse: "159",
        email: "themesbrand@steex.com",
        experience: "2 Years",
        students: "49",
        contact: "+(123) 15962 32145",
        rating: "4.9",
        status: "Active"
    }, {
        id: 11,
        img: { priview: avatar6, formattedSize: "4.87 KB", path: "img-6.png", size: '3000' },
        imgalt: "avatar-6.jpg",
        name: "Sarai Schmidt",
        totalcourse: "320",
        email: "sarai@steex.com",
        experience: "5 Years",
        students: "364",
        contact: "+(123) 01592 36544",
        rating: "4.7",
        status: "Active"
    }
]

const studentsinstructor = [
    {
        id: 1,
        img: avatar1,
        title: 'Soledad Vandervort',
        email: 'vandervort@steex.com',
        contact: '(512) 34682 17935',
        courses: '8',
        date: '12 March, 2023',
        status: 'Active'
    },
    {
        id: 2,
        img: avatar7,
        title: 'Marcelino Smith',
        email: 'marcelino@steex.com',
        contact: '(210) 95162 15935',
        courses: '0',
        date: '  29 Feb, 2023',
        status: 'New'
    },
    {
        id: 3,
        img: avatar4,
        title: 'Vinnie Huels',
        email: 'Vinnie Huels',
        contact: '(105) 93521 23165',
        courses: '2',
        date: ' 06 Feb, 2023',
        status: 'Unactive'
    },
    {
        id: 4,
        img: avatar5,
        title: 'Deondre Huel',
        email: 'deondrehuel@steex.com',
        contact: '(532) 35795 15935',
        courses: '9',
        date: '  29 Jan, 2023',
        status: 'Active'
    },
    {
        id: 5,
        img: avatar8,
        title: 'Zachary Stokes',
        email: 'zacharystokes@steex.com',
        contact: '(44) 98765 32104',
        courses: '3',
        date: ' 09 Jan, 2023',
        status: 'Active'
    },

]


export { instructor, studentsinstructor };